import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import * as commonApi from '../api';

export const createTestCaseActions = (types, api) => ({
  changePage: createAction(types.CHANGE_PAGE),
  resetPage: createAction(types.RESET_PAGE),
  cleanup: createAction(types.CLEANUP),
  changeSorting: createAction(types.CHANGE_SORTING),
  updateTestOwner: createAction(types.UPDATE_TEST_OWNER),
  initialized: createAction(types.INITIALIZED),
  changeTrendsInterval: createAction(types.CHANGE_TRENDS_INTERVAL),
  changeSelectedBar: createAction(types.CHANGE_SELECTED_BAR),
  getTests: createApiAction(
    types.GET_TESTS,
    (params) => api.getTests(params),
    { meta: { skipErrorPage: true } },
  ),
  getTestCasesTrends: createApiAction(
    types.GET_TEST_CASES_TRENDS,
    (params) => api.getTestCasesTrends(params),
    { meta: { skipErrorPage: true } },
  ),
  fetchUsers: createApiAction(
    types.FETCH_USERS,
    () => commonApi.fetchUsers(),
    { meta: { skipErrorPage: true } },
  ),
  fetchUser: createApiAction(
    types.FETCH_USER,
    (payload) => commonApi.fetchUser(payload),
    { meta: { skipErrorPage: true } },
  ),
});
